export const ENCRYPTION_KEY = '2013;[pnuLIT)WebCodeExpert';
export const GET_ALL_COUNTRIES = 'GET_ALL_COUNTRIES';
export const DATA_SECRET = 'nutri123dash@-_!app';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_AD_USER = 'LOGIN_AD_USER';
export const LOGIN_AD_USER_SUCCESS = 'LOGIN_AD_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGIN_AD_USER_FAILURE = 'LOGIN_AD_USER_FAILURE';
export const UNMOUNT_REGISTER = 'UNMOUNT_REGISTER';
export const UNMOUNT_REGISTER_USER_SUCCESS = 'UNMOUNT_REGISTER_USER_SUCCESS';
export const CLEAR_USER = 'CLEAR_USER';
export const VERIFY_CAPTCHA = 'VERIFY_CAPTCHA';
export const VERIFY_CAPTCHA_SUCCESS = 'VERIFY_CAPTCHA_SUCCESS';
export const GET_APP_SETTINGS = 'GET_APP_SETTINGS';
export const GET_APP_SETTINGS_SUCCESS = 'GET_APP_SETTINGS_SUCCESS';

export const USER_LIST = 'USER_LIST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_FILTER_UPDATE = 'USER_LIST_FILTER_UPDATE';
export const USER_LIST_PAGE_UPDATE = 'USER_LIST_PAGE_UPDATE';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
export const SAVE_USER_DETAILS = 'SAVE_USER_DETAILS';
export const SAVE_USER_DETAILS_SUCCESS = 'SAVE_USER_DETAILS_SUCCESS';
export const PENDING_USER_LIST = 'PENDING_USER_LIST';
export const UPDATE_PENDING_USER_LIST = 'UPDATE_PENDING_USER_LIST';
export const PENDING_USER_LIST_SUCCESS = 'PENDING_USER_LIST_SUCCESS';
export const UPDATE_PENDING_USER_LIST_SUCCESS = 'UPDATE_PENDING_USER_LIST_SUCCESS';
export const REJECTED_USER_LIST = 'REJECTED_USER_LIST';
export const REJECTED_USER_LIST_SUCCESS = 'REJECTED_USER_LIST_SUCCESS';
export const SHARE_LINK_BY_EMAIL = 'SHARE_LINK_BY_EMAIL';
export const SHARE_LINK_BY_EMAIL_SUCCESS = 'SHARE_LINK_BY_EMAIL_SUCCESS';

export const MODULE_LIST = 'MODULE_LIST';
export const MODULE_LIST_SUCCESS = 'MODULE_LIST_SUCCESS';
export const MODULE_LIST_BY_SURVEY = 'MODULE_LIST_BY_SURVEY';
export const MODULE_LIST_BY_SURVEY_SUCCESS = 'MODULE_LIST_BY_SURVEY_SUCCESS';
export const MODULE_LIST_FILTER_UPDATE = 'MODULE_LIST_FILTER_UPDATE';
export const MODULE_LIST_PAGE_UPDATE = 'MODULE_LIST_PAGE_UPDATE';
export const MODULE_LIST_SORT = 'MODULE_LIST_SORT';
export const MODULE_EDIT_METADATA_SUCCESS = 'MODULE_EDIT_METADATA_SUCCESS';
export const MODULE_EDIT_METAINFO = 'MODULE_EDIT_METAINFO';
export const MODULE_EDIT_METADATA_UPDATE = 'MODULE_EDIT_METADATA_UPDATE';
export const MODULE_PAGE_PREVIEW = 'MODULE_PAGE_PREVIEW';
export const MODULE_PAGE_PREVIEW_SUCCESS = 'MODULE_PAGE_PREVIEW_SUCCESS';
export const SAVE_MODULE = 'SAVE_MODULE';
export const SAVE_MODULE_SUCCESS = 'SAVE_MODULE_SUCCESS';
export const DELETE_MODULE = 'DELETE_MODULE';
export const DELETE_MODULE_SUCCESS = 'DELETE_MODULE_SUCCESS';
export const USER_ASSIGNED_COUNTRY_LIST = 'USER_ASSIGNED_COUNTRY_LIST';
export const USER_ASSIGNED_COUNTRY_LIST_SUCCESS = 'USER_ASSIGNED_COUNTRY_LIST_SUCCESS';
export const UPDATE_USER_ASSIGNED_COUNTRY = 'UPDATE_USER_ASSIGNED_COUNTRY';
export const UNMOUNT_PREVIEW_RESPONSE = 'UNMOUNT_PREVIEW_RESPONSE';
export const UNMOUNT_PREVIEW_RESPONSE_SUCCESS = 'UNMOUNT_PREVIEW_RESPONSE_SUCCESS';
export const UNMOUNT_MODULE_LIST_RESPONSE = 'UNMOUNT_MODULE_LIST_RESPONSE';
export const UNMOUNT_MODULE_LIST_RESPONSE_SUCCESS = 'UNMOUNT_MODULE_LIST_RESPONSE_SUCCESS';
export const UNMOUNT_USER_ASSIGNED_COUNTRY_LIST_SUCCESS = 'UNMOUNT_USER_ASSIGNED_COUNTRY_LIST_SUCCESS';



export const SAVE_MODULE_QUESTIONS = 'SAVE_MODULE_QUESTIONS';
export const SAVE_MODULE_QUESTIONS_SUCCESS = 'SAVE_MODULE_QUESTIONS_SUCCESS';

export const COUNTRY_LIST = 'COUNTRY_LIST';
export const COUNTRY_LIST_SUCCESS = 'COUNTRY_LIST_SUCCESS';
export const SET_COUNTRY = 'SET_COUNTRY';
export const ROLE_LIST = 'ROLE_LIST';
export const ROLE_LIST_SUCCESS = 'ROLE_LIST_SUCCESS';
export const REGION_LIST = 'REGION_LIST';
export const REGION_LIST_SUCCESS = 'REGION_LIST_SUCCESS';

export const COUNTRY_BY_REGION_LIST = 'COUNTRY_BY_REGION_LIST';
export const COUNTRY_BY_REGION_SUCCESS = 'COUNTRY_BY_REGION_SUCCESS';


export const UPDATE_MODULE_DATA = 'UPDATE_MODULE_DATA';
export const UPDATE_MODULE_DATA_SUCCESS = 'UPDATE_MODULE_DATA_SUCCESS';

export const SURVEY_LIST = 'SURVEY_LIST';
export const GLOBAL_SURVEY_LIST_SUCCESS = 'GLOBAL_SURVEY_LIST_SUCCESS';
export const SURVEY_LIST_SUCCESS = 'SURVEY_LIST_SUCCESS';
export const SURVEY_LIST_FILTER_UPDATE = 'SURVEY_LIST_FILTER_UPDATE';
export const SURVEY_LIST_PAGE_UPDATE = 'SURVEY_LIST_PAGE_UPDATE';
export const SAVE_SURVEY = 'SAVE_SURVEY';
export const SAVE_SURVEY_SUCCESS = 'SAVE_SURVEY_SUCCESS';
export const SAVE_SURVEY_FAIL= 'SAVE_SURVEY_FAIL';
export const EDIT_SURVEY = 'EDIT_SURVEY';
export const GET_QUESTION_STATUS = 'GET_QUESTION_STATUS';
export const RESET_QUESTION_STATUS = 'RESET_QUESTION_STATUS';
export const EDIT_SURVEY_SUCCESS = 'EDIT_SURVEY_SUCCESS';
export const GET_STATUS_QUESTION_SUCCESS = 'GET_STATUS_QUESTION_SUCCESS';
export const SET_SAVE_SURVEY_STATUS = 'SET_SAVE_SURVEY_STATUS';
export const PUBLISH_SURVEY = 'PUBLISH_SURVEY';
export const DELETE_SURVEY = 'DELETE_SURVEY';
export const DELETE_SURVEY_SUCCESS = 'DELETE_SURVEY_SUCCESS';
export const UPDATE_SURVEY_DATE = 'UPDATE_SURVEY_DATE';
export const UPDATE_SURVEY_DATE_SUCCESS = 'UPDATE_SURVEY_DATE_SUCCESS';
export const UNMOUNT_ADDEDIT_SURVEY = 'UNMOUNT_ADDEDIT_SURVEY';
export const UNMOUNT_ADDEDIT_SURVEY_SUCCESS = 'UNMOUNT_ADDEDIT_SURVEY_SUCCESS';

export const FETCH_SURVEY_RESPONSE = 'FETCH_SURVEY_RESPONSE';
export const FETCH_SURVEY_RESPONSE_SUCCESS = 'FETCH_SURVEY_RESPONSE_SUCCESS';

export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
export const GET_DASHBOARD_DATA_OFFLINE = 'GET_DASHBOARD_DATA_OFFLINE';
export const GET_DASHBOARD_DATA_SUCCESS = 'GET_DASHBOARD_DATA_SUCCESS';

export const SHOW__HIDE_LOADER = 'SHOW__HIDE_LOADER';

export const LOGOUT = 'LOGOUT';
export const IS_UNAUTHORIZED = 'IS_UNAUTHORIZED';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const IS_ERROR = 'IS_ERROR';

export const GET_ADMIN_DASHBOARD_DATA = 'GET_ADMIN_DASHBOARD_DATA';
export const GET_ADMIN_DASHBOARD_DATA_SUCCESS = 'GET_ADMIN_DASHBOARD_DATA_SUCCESS';

export const GET_REGIONAL_ADMIN_DASHBOARD_DATA = 'GET_REGIONAL_ADMIN_DASHBOARD_DATA';
export const GET_REGIONAL_ADMIN_DASHBOARD_DATA_SUCCESS = 'GET_REGIONAL_ADMIN_DASHBOARD_DATA_SUCCESS';

export const UNMOUNT_DASHBOARD_DATA = 'UNMOUNT_DASHBOARD_DATA';
export const UNMOUNT_DASHBOARD_DATA_SUCCESS = 'UNMOUNT_DASHBOARD_DATA_SUCCESS';

export const GET_COUNTRY_MODULE_DATA = 'GET_COUNTRY_MODULE_DATA';
export const GET_COUNTRY_MODULE_DATA_SUCCESS = 'GET_COUNTRY_MODULE_DATA_SUCCESS';


export const SAVE_REMINDER_CONFIG = 'SAVE_REMINDER_CONFIG';
export const SAVE_REMINDER_CONFIG_ADMIN_SUCCESS = 'SAVE_REMINDER_CONFIG_ADMIN_SUCCESS';
export const SAVE_REMINDER_CONFIG_REGIONAL_SUCCESS = 'SAVE_REMINDER_CONFIG_REGIONAL_SUCCESS';
export const GET_QUESTION_VERSIONS = 'GET_QUESTION_VERSIONS';
export const GET_QUESTION_VERSIONS_SUCCESS = 'GET_QUESTION_VERSIONS_SUCCESS';
export const UNMOUNT_EDIT_USER = 'UNMOUNT_EDIT_USER';
export const UNMOUNT_EDIT_USER_SUCCESS = 'UNMOUNT_EDIT_USER_SUCCESS';

export const GET_LAST_YEAR__QUESTION_RESPONSE = 'GET_LAST_YEAR__QUESTION_RESPONSE';
export const GET_LAST_YEAR__QUESTION_RESPONSE_SUCCESS = 'GET_LAST_YEAR__QUESTION_RESPONSE_SUCCESS';

export const DOWNLOAD_EXCEL = 'DOWNLOAD_EXCEL';
export const DOWNLOAD_ZIP = 'DOWNLOAD_ZIP';

export const DATACOLLECTOR_DASHBOARD_KEY = 'DATACOLLECTOR_DASHBOARD_KEY';
export const DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY = 'DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY';
export const GET_DASHBOARD_DATA_OFFLINE_SUCCESS = 'GET_DASHBOARD_DATA_OFFLINE_SUCCESS';
export const FETCH_SURVEY_RESPONSE_OFFLINE = 'FETCH_SURVEY_RESPONSE_OFFLINE';
export const FETCH_SURVEY_RESPONSE_OFFLINE_SUCCESS = 'FETCH_SURVEY_RESPONSE_OFFLINE_SUCCESS';
export const SET_SURVEY_RESPONSE_OFFLINE = 'SET_SURVEY_RESPONSE_OFFLINE';
export const DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY = 'DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY';
export const SYNC_SURVEY_RESPONSE_OFFLINE = 'SYNC_SURVEY_RESPONSE_OFFLINE';
export const SYNC_SURVEY_RESPONSE_OFFLINE_SUCCESS = 'SYNC_SURVEY_RESPONSE_OFFLINE_SUCCESS';
export const SYNC_SURVEY_GET_USER_COUNTRIES_KEY = 'SYNC_SURVEY_GET_USER_COUNTRIES_KEY';
export const SET_OFFLINE_MODE = 'SET_OFFLINE_MODE';
export const SET_OFFLINE_MODE_SUCCESS = 'SET_OFFLINE_MODE_SUCCESS';
export const SYNC_SURVEY_RESPONSE_OFFLINE_COMPLETED = 'SYNC_SURVEY_RESPONSE_OFFLINE_COMPLETED';
export const SYNC_SURVEY_RESPONSE_OFFLINE_COMPLETED_SUCCESS = 'SYNC_SURVEY_RESPONSE_OFFLINE_COMPLETED_SUCCESS';

export const SAVE_MODULE_RESPONSE = 'SAVE_MODULE_RESPONSE';
export const ALLOWED_MULTISELECT_ROLE_IDS = [2, 7, 8];
export const APPROVE_QUESTION = 'APPROVE_QUESTION';
export const ASSIGN_CREATOR = 'ASSIGN_CREATOR';


// WEBPACK FOOTER //
// ./src/constants/constants.tsx